<template>
  <div class="wrap">
    <Nav :title="$t('newAdd.withdraw')" fixed safeAreaInsetTop placeholder>
      <template #right>
        <div class="right_btn" @click="handleLinkPage('withdraw-list')">
          {{ $t("newAdd.record") }}
        </div>
      </template>
    </Nav>
    <div class="content_wrap">
      <div class="bank">
        <div class="bank_item">
          <div class="title">{{ $t("bankName") }}</div>
          <div class="options">{{ bankInfo.bank || "" }}</div>
        </div>
        <div class="bank_item">
          <div class="title">{{ $t("bankCard") }}</div>
          <div class="options">
            {{ bankInfo.card || "" }}
          </div>
        </div>
      </div>
      <div class="money">
        <div class="title">{{ $t("withdrawNum") }}</div>
        <div class="input_wrap">
          <input type="text" v-model="money" placeholder="0.00" />
          <div class="right">
            <div class="btn" @click="money = userInfo.money">
              {{ $t("AllOut") }}
            </div>
            <div class="unit">{{ verConfig.moneyType }}</div>
          </div>
        </div>
        <div class="balance">
          <span class="title">{{ $t("Balance") }}:&nbsp;&nbsp;</span>
          <span class="value">{{ userInfo.money || "0.00" }}&nbsp;&nbsp;{{ verConfig.moneyType }}</span>
        </div>
        <div class="actualAmount">
          <span class="title">{{ $t("actualAmount") }}:&nbsp;&nbsp;</span>
          <span class="value">{{ money || "0.00" }}&nbsp;&nbsp;{{ verConfig.moneyType }}</span>
        </div>
      </div>
      <div class="submit" @click="Withdrawal">{{ $t("submit") }}</div>
    </div>
  </div>
</template>

<script>
import { GET_USER_BANK_INFO, WITHDRAW, getUserInfoNew, extract } from "@/api";
import Cookies from "js-cookie";
import { Icon, Picker, Popup, Toast, Dialog } from "vant";
import Nav from "@/components/Navbar";
import { isObject, count, getToken } from "@/utils";
import { mapGetters } from "vuex";
export default {
  components: {
    Nav,
    [Icon.name]: Icon,
    [Picker.name]: Picker,
    [Popup.name]: Popup
  },
  data() {
    return {
      money: "",
      bankInfo: {},
      isshowDialog: false,
      editValue: "",
      money_not: 0,
      paypassword: this.$route.query.paypassword
        ? this.$route.query.paypassword
        : true,
      withdrawType: "bank",
      rateData: {},
      showPicker: false,
      banks: [],
      amount: "",
      handlingFeeData: [],
    };
  },

  computed: {
    ...mapGetters(['userInfo']),
    money_can() {
      return this.userInfo.money_not > 0 ? 0 : this.userInfo.money;
    },
    actualAmount() {
      let amount = 0;
      if (Number(this.money)) {
        if (String(this.rateData.value).indexOf("%") === -1) {
          amount = (this.money - this.rateData.value) / this.rateData.rate;
        } else {
          const fixedNum = 100000000;
          amount =
            Math.round(
              ((this.money *
                (1 -
                  String(this.rateData.value).substring(
                    0,
                    String(this.rateData.value).indexOf("%")
                  ) /
                  100)) /
                this.rateData.rate) *
              fixedNum
            ) / fixedNum;
        }
      }
      return amount > 0 ? amount : 0;
    },
    handlingFee() {
      const item =
        this.handlingFeeData.find((a) => a.name === this.bankInfo.open) || {};
      return item.value == "0" ? "0.00" : item.value;
    },
  },
  created() {
    this.getUserBankInfo();
    this.$store.dispatch('getUserInfo')
  },
  methods: {
    confirm() {
      WITHDRAW({
        money: this.money,
        bankid: this.bankInfo.id,
      }).then((r) => {
        const { ret, data, msg } = r;
        if (ret == 1) {
          this.$store.dispatch('getUserInfo')
          this.$router.back();
          return
        }
        return this.$toast(msg)
      }).catch((e) => {
        Toast.clear()
      });
    },
    Withdrawal() {
      this.confirm();
    },
    allHandler() {
      this.money = this.userInfo.money;
    },
    getUserBankInfo() {
      GET_USER_BANK_INFO().then((r) => {
        Toast.clear();
        if (isObject(r.data) && count(r.data) > 0) {
          this.bankInfo = r.data[0]
        } else {
          Dialog.confirm({
            title: this.$t("newAdd.warmTitle"),
            confirmButtonText: this.$t("user.Button.Two"),
            cancelButtonText: this.$t("user.Button.One"),
            message: this.$t("newAdd.NotHaveCard"),
          }).then((res) => {
            this.itemClick("BankCardAdd");
          }).catch((err) => {
            this.$router.back();
          });
        }
      }).catch((e) => { });
    },
    itemClick(page) {
      this.$router.push({ name: page });
    },
    handleLinkPage(path) {
      this.$router.push(`/${path}`);
    },
  },
};
</script>
<style lang="less" scoped>
@theme: var(--nav-background);

.wrap {
  min-height: 100vh;
  background: var(--bgImg) no-repeat;
  background-size: cover;

  .right_btn {
    padding: calc(6rem / 16) calc(12rem / 16);
    font-size: calc(14rem / 16);
    background-color: var(--white);
    color: var(--black);
    border-radius: calc(4rem / 16);
  }

  .content_wrap {
    @paddingHor: calc(12rem / 16);
    padding: calc(20rem / 16) calc(10rem / 16);
    border-radius: calc(8rem / 16);

    .bank {
      background-color: var(--white);
      border-radius: calc(8rem / 16);

      .bank_item {
        padding: calc(5rem / 16) calc(10rem / 16);
        border-bottom: 1px dashed silver;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .title {
          font-size: calc(14rem / 16);
          line-height: calc(30rem / 16);
          color: #999;
        }

        .options {
          padding: 0 calc(10rem / 16);
          line-height: calc(30rem / 16);
          color: #606266;
          font-size: calc(14rem / 16);
        }
      }

      .bank_item:last-child {
        border-bottom-width: 0;
      }
    }

    .money {
      background-color: var(--white);
      margin-top: calc(20rem / 16);
      padding: calc(10rem / 16);
      border-radius: calc(8rem / 16);

      .title {
        font-size: calc(16rem / 16);
        color: var(--theme);
      }

      .input_wrap {
        display: flex;
        background: var(--newbg);
        width: calc(100% - @paddingHor + 4rem / 16 - 24rem / 16);
        margin-top: calc(12rem / 16);
        height: calc(40rem / 16);
        align-items: center;
        justify-content: space-between;
        border-radius: calc(4rem / 16);
        padding: 0 calc(12rem / 16);

        input {
          background: transparent;
          border: 0;
          line-height: calc(36rem / 16);
          flex-grow: 1;
          color: var(--sizeColor);
        }

        .right {
          display: flex;
          align-items: center;
          font-size: calc(14rem / 16);

          .btn {
            color: var(--theme);

            &:active {
              opacity: 0.7;
            }
          }

          .unit {
            margin-left: calc(12rem / 16);
            color: var(--theme);
          }
        }
      }

      .balance,
      .handlingFee,
      .actualAmount {
        margin-top: calc(10rem / 16);

        .title {
          font-size: calc(12rem / 16);
          color: #999;
        }

        .value {
          color: var(--theme);
          font-size: calc(14rem / 16);
        }
      }
    }



    .submit {
      font-size: calc(16rem / 16);
      background: var(--btnColor);
      color: var(--white);
      text-align: center;
      line-height: calc(45rem / 16);
      width: calc(100% - @paddingHor + 4rem / 16);
      margin: calc(60rem / 16) 0;
      margin-bottom: calc(30rem / 16);
      border-radius: calc(4rem / 16);

      &:active {
        opacity: 0.7;
      }
    }
  }
}
</style>